import Model from "@/lib/model/model";
import request from "@/lib/request/request";

/**
 * H5端 候选人登录时获取验证码
 * 使用场景：
 *  1. H5 人脸核身
 */
export default class Captcha extends Model {
  code = 0;
  message = "";
  static updateJobExam(p: any) {
    return request.post("aiExam/job/examUpdate", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }

  static async get(phone: string) {
    return request
      .post("aiExam/uc/sendCaptcha", { phone: phone }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  static async check(phone: string, captcha: string) {
    return request
      .post("aiExam/uc/checkCaptcha", { phone: phone, captcha: captcha }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  static async getPromise(phone: string) {
    return request
      .post("aiExam/uc/sendCaptcha", { phone: phone }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  static async CheckPromise(phone: string, captcha: string) {
    return request
      .post("aiExam/uc/checkCaptcha", { phone: phone, captcha: captcha }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }
}
